import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { Swiper, SwiperSlide } from "swiper/react"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import { useAppSelector } from "appRedux/hooks"
import { updateCurrentPopularItemIndex } from "appRedux/slices/feedSlice"
import FeedCard from "components/organisms/FeedCard"
import SwiperIndicator from "components/molecules/SwiperIndicator"
import FeedNewItemSummary from "components/molecules/FeedNewItemSummary"

export default function Index() {
  const currentSlideIndex = useAppSelector(state => state.feed.currentPopularItemIndex)
  const popularItems = useAppSelector(state => state.wishItem.popularItems)

  const dispatch = useDispatch()
  const { t } = useTranslation()

  function handleOnSlideChange(swiperEvent: any) {
    dispatch(updateCurrentPopularItemIndex(swiperEvent.activeIndex))
  }

  return (
    (popularItems && popularItems.length > 0) ? <Container>
      <Title>{t("feed.popularItems")}</Title>
      <Swiper
        dir="ltr"
        initialSlide={currentSlideIndex}
        resistanceRatio={0}
        edgeSwipeDetection={true}
        onSlideChange={handleOnSlideChange}
      >
        {popularItems.map((item, index) => (
          <SwiperSlide key={index}>
            <div dir="rtl">
              <FeedCard key={index} type={"NEW_ITEM"}>
                <FeedCard.ContentWrapper>
                  <FeedCard.User user={item.user}/>
                  <FeedCard.Divider/>
                  <FeedNewItemSummary
                    index={index}
                    id={item.id}
                    name={item.name}
                    image={item.image}
                    isLiked={item.isLiked}
                    likesCount={item.likeCount}
                    commentsCount={item.commentCount}
                    lists={[]}
                    user={item.user}
                  />
                </FeedCard.ContentWrapper>
              </FeedCard>
            </div>
          </SwiperSlide>
        ))}
        <div style={{
          width: "100%",
          height: "24px"
        }}></div>
      </Swiper>
      <SwiperIndicator
        slidesCount={popularItems.length}
        currentSlideIndex={currentSlideIndex}
        mode={"light"}
        size="small"
      />
    </Container> : null
  )
}

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.gray["4"],
  padding: "16px",
  gap: "20px",
  position: "relative",
  marginBottom: "8px",

  "& div.swiper": {
    width: "100%"
  }
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))
